import $ from 'jquery';
var popups = [];

window.gwrf = function (args) {

	// prototype arguments, created when we instantiate it
	this.formId = args.formId;
	this.spinnerUrl = args.spinnerUrl;
	this.refreshTime = args.refreshTime;
	this.el = args.el;
	this.refreshTimeout = null;



	// form wrapper class followed by the form id
	this.formWrapper = this.el.find('#gform_wrapper_' + this.formId);
	this.staticElem = this.formWrapper.parent();

	// we want to make sure that we'll have the cloned form html
	this.formHtml = $('<div />').append(this.formWrapper.clone()).html();

	this.spinnerInitialized = false;

	var gwrf = this;

	$(document).bind('gform_confirmation_loaded', (event, formId) => {
		this.reloadForm()
	});

	// heart of our functionality
	this.reloadForm = function () {
		// let's check if the confirmation message has already been created
		if (this.el.find('#gform_confirmation_message_' + this.formId).length) {
			if (this.refreshTimeout)
				clearTimeout(this.refreshTimeout);

			// let's look for the confirmation element and get the HTML of the parent form
			this.el.find('#gform_confirmation_message_' + this.formId)
				.wrap('<div />').parent().html(this.formHtml);

			if(this.formId == 7) {
				this.el.find('#gform_confirmation_wrapper_' + this.formId)
					.prepend('<div style="background:#94e094;padding:20px;margin-bottom:20px;">Thank you for your question! We will answer your question during the Q&amp;A or contact you later by email.<br>Feel free to ask another question.</div>');
			}

			// let's get rid of the HTML of the FORM
			this.el.find('#gform_wrapper_' + this.formId).unwrap();

			// let's rerender the form
			$(document).trigger('gform_post_render', [this.formId, 0]);

			// if we had datepicker let's reinstantiate it
			if (window['gformInitDatepicker'])
				gformInitDatepicker();
		}
	};

	// utility used to display the "spinner" loading image
	this.initSpinner = function () {

		var gwrf = this;

		this.staticElem.on('submit', '#gform_' + this.formId, function () {
			$('#gform_submit_button_' + gwrf.formId).attr('disabled', true).after('<' + 'img id=\"gform_ajax_spinner_' + gwrf.formId + '\"  class=\"gform_ajax_spinner\" src=\"' + gwrf.spinnerUrl + '\" />');
			gwrf.formWrapper.find('.gform_previous_button').attr('disabled', true);
			gwrf.formWrapper.find('.gform_next_button').attr('disabled', true).after('<' + 'img id=\"gform_ajax_spinner_' + gwrf.formId + '\"  class=\"gform_ajax_spinner\" src=\"' + gwrf.spinnerUrl + '\" alt=\"\" />');
		});

	};

	// this.init();
};
